(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-results/assets/javascripts/models/round.js') >= 0) return;  svs.modules.push('/modules/game-results/assets/javascripts/models/round.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$lbUti = svs.components.lbUtils.apiProxy,
  ApiProxy = _svs$components$lbUti.ApiProxy,
  http = _svs$components$lbUti.http,
  featureToggle = _svs$components$lbUti.featureToggle;
const cloudApiFeatureToggles = svs.components.lbUtils.cloudApi.cloudApiConstants.cloudApiFeatureToggles;
const cloudSocket = svs.core.svsSocket.get('/v1/gameinfo-soc');
const VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW = svs.components.lbUtils.cloudApi.cloudApiConstants.VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW;
svs.game_results.models.Round = Backbone.Model.extend({
  async initialize(attributes) {
    const _await$Promise$all = await Promise.all([this.getDraw(attributes.product, attributes.drawNumber), this.getDrawResult(attributes.product, attributes.drawNumber), this.getDrawForecast(attributes.product, attributes.drawNumber)]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 3),
      drawResponse = _await$Promise$all2[0],
      resultResponse = _await$Promise$all2[1],
      forecastResponse = _await$Promise$all2[2];
    if (forecastResponse && forecastResponse.data) {
      const forecast = forecastResponse.data;
      const drawState = forecast.drawState;
      const roundIsLive = drawState >= svs.game_results.constants.drawStates.CLOSED && drawState < svs.game_results.constants.drawStates.FINALIZED;
      this.set('roundIsLive', roundIsLive);
      this.set('drawState', drawState, {
        silent: true
      });
      if (drawResponse && drawResponse.data) {
        const draw = drawResponse.data;
        const rowPrice = draw.rowPrice;
        forecast.winresult.forEach(currentForecast => {
          currentForecast.winAmount = Math.floor(parseFloat(svs.utils.format.CurrencyFromJupiterString(currentForecast.winValue) * parseInt(rowPrice, 10)));
        });
      }
      this.set('forecast', forecast);
      this.set('winresult', forecast.winresult);
    }
    if (resultResponse && resultResponse.data) {
      const result = resultResponse.data;
      this.set('result', result);
    }
    if (drawResponse && drawResponse.data) {
      const draw = drawResponse.data;
      if (draw.drawStateId < svs.game_results.constants.drawStates.CLOSED) {
        this.set('isBeforeStart', true);
      }

      if (draw.productId === svs.game_results.constants.productId.BOMBEN) {
        draw.currentNetSale = draw.currentNetSales;
        draw.drawEvents = draw.events;
      }
      if (draw.sport && draw.sport.type === svs.components.sport.sportTypes.SportTypes.Trotting) {
        this.set('isTrotting', true);
      }
      this.set('draw', draw);
    }
    const currentProduct = this.get('product');
    const currentDrawNumber = this.get('drawNumber');
    const liveResultsSocketPath = "/draw/1/".concat(currentProduct, "/draws/").concat(currentDrawNumber);
    const forecastSocketPath = "/draw/1/".concat(currentProduct, "/draws/forecast/").concat(currentDrawNumber);
    const drawProductId = drawResponse && drawResponse.data ? drawResponse.data.productId : null;
    const useCloudSocketApi = drawProductId && currentProduct && svs.core.detect.feature(cloudApiFeatureToggles[currentProduct.toUpperCase()]) && VALID_PRODUCTS_FOR_CLOUD_SOCKET_ENDPOINT_DRAW.includes(drawProductId);
    if (useCloudSocketApi) {
      const cloudLiveResultsSocketPath = "/api/v1/".concat(currentProduct, "/draws/").concat(currentDrawNumber);
      const self = this;
      const cloudLiveResultsHandler = function (response) {
        if (response && response.message && response.message.data && response.message.data.draw) {
          self.liveResultsSocketUpdate({
            draw: response.message.data.draw
          });
        }
      };
      const cloudSubscription = cloudSocket.subscribe(cloudLiveResultsSocketPath, cloudLiveResultsHandler, {
        sendInitialUpdate: false
      });
      this.set('cloudSubscription', cloudSubscription, {
        silent: true
      });
    } else {
      svs.core.socket.subscribe(liveResultsSocketPath, this.liveResultsSocketUpdate, this, false);
    }
    svs.core.socket.subscribe(forecastSocketPath, this.forecastSocketUpdate, this, false);
  },
  unsubscribeSockets() {
    if (this.get('cloudSubscription')) {
      this.get('cloudSubscription').unsubscribe();
    }
    if (this.get('liveResultsSocketPath')) {
      svs.core.socket.unsubscribe(this.get('liveResultsSocketPath'), this.liveResultsSocketUpdate);
    }
    if (this.get('forecastSocketPath')) {
      svs.core.socket.unsubscribe(this.get('forecastSocketPath'), this.forecastSocketUpdate);
    }
  },
  async getDraw(productName, drawNumber) {
    const customHandlerDraw = http.get('/draw/1/:product/draws/:drawNumber', _ref => {
      let data = _ref.data;
      return data;
    }, {
      config: {
        shouldUseCloud: async () => {
          const isEnabled = await featureToggle(cloudApiFeatureToggles[productName.toUpperCase()], {
            req: undefined
          });
          return isEnabled;
        },
        allowedProducts: ['bomben'],
        cloudEndpointTemplate: '/v1/:product/draws/:drawNumber'
      }
    });
    const apiProxyDraw = new ApiProxy([customHandlerDraw]);
    try {
      const drawData = await apiProxyDraw.fetch("/draw/1/".concat(productName, "/draws/").concat(drawNumber), {
        method: 'GET',
        req: undefined
      });
      if (!drawData || !drawData.draw) {
        return {
          data: undefined,
          error: new Error("Draw data not found for product ".concat(productName, " and draw number ").concat(drawNumber))
        };
      }
      return {
        data: drawData.draw,
        error: undefined
      };
    } catch (error) {
      return {
        data: undefined,
        error: new Error("Error fetching draw data for product ".concat(productName, " and draw number ").concat(drawNumber, ": ").concat(error.message))
      };
    }
  },
  async getDrawResult(productName, drawNumber) {
    const customHandlerDrawResult = http.get('/draw/1/:product/draws/:drawNumber/result', _ref2 => {
      let data = _ref2.data;
      return data;
    }, {
      config: {
        shouldUseCloud: async () => {
          const isEnabled = await featureToggle(cloudApiFeatureToggles[productName.toUpperCase()], {
            req: undefined
          });
          return isEnabled;
        },
        allowedProducts: ['bomben'],
        cloudEndpointTemplate: '/v1/:product/draws/:drawNumber/result'
      }
    });
    const apiProxyDrawResult = new ApiProxy([customHandlerDrawResult]);
    try {
      const resultData = await apiProxyDrawResult.fetch("/draw/1/".concat(productName, "/draws/").concat(drawNumber, "/result"), {
        method: 'GET',
        req: undefined
      });
      if (!resultData || !resultData.result) {
        return {
          data: undefined,
          error: new Error("Result data not found for product ".concat(productName, " and draw number ").concat(drawNumber))
        };
      }
      return {
        data: resultData.result,
        error: undefined
      };
    } catch (error) {
      return {
        data: undefined,
        error: new Error("Error fetching result data for product ".concat(productName, " and draw number ").concat(drawNumber, ": ").concat(error.message))
      };
    }
  },
  async getDrawForecast(productName, drawNumber) {
    try {
      const response = await svs.core.jupiter.callAsync({
        method: 'GET',
        path: "/draw/1/".concat(productName, "/draws/forecast/").concat(drawNumber)
      });
      return {
        data: response.response.forecastResult || undefined,
        error: response.error || undefined
      };
    } catch (error) {
      return {
        data: undefined,
        error: new Error("Error fetching forecast data for product ".concat(productName, " and draw number ").concat(drawNumber, ": ").concat(error.message))
      };
    }
  },
  async setFinalResult(forecastResult) {
    const currentProduct = this.get('product');
    try {
      const forecastResponse = await this.getDrawForecast(currentProduct, forecastResult.drawnum);
      if (forecastResponse.error) {
        this.updateForecast(forecastResult);
      }
      if (forecastResponse && forecastResponse.data) {
        this.updateForecast(forecastResponse.data);
      }
    } catch (error) {
      this.updateForecast(forecastResult);
    }
  },
  updateForecast(forecastResult) {
    this.set('forecast', forecastResult);
    this.set('changes', forecastResult.changes, {
      silent: true
    });
    this.set('resultIdx', forecastResult.resultIdx);
    this.set('drawState', forecastResult.drawState);
  },
  forecastSocketUpdate(value) {
    if (value.forecastResult) {
      const forecastResult = value.forecastResult;
      if (this.get('isBeforeStart') && forecastResult.drawState >= svs.game_results.constants.drawStates.CLOSED) {
        this.set('isBeforeStart', false);
      }
      const roundIsLive = forecastResult.drawState >= svs.game_results.constants.drawStates.CLOSED && forecastResult.drawState < svs.game_results.constants.drawStates.FINALIZED;
      this.set('roundIsLive', roundIsLive);
      if (forecastResult.drawState === svs.game_results.constants.drawStates.FINALIZED) {
        this.setFinalResult(forecastResult);
      } else {
        this.updateForecast(forecastResult);
      }
    }
  },
  liveResultsSocketUpdate(value) {
    if (value.draw) {
      this.set('liveResults', value.draw);
    }
  }
});

 })(window);